export const state = () => ({
  successMessage: '',
  appeared: false,
  statistics: null,
  errorMessage: {},
  loginForFirstTime: null,
  status_code: null
})

export const mutations = {
  SET_ADMIN (state, payload) {
    state.admin = payload
  },
  RESPONSEMESSAGE (state, payload) {
    state.successMessage = payload.message
  },
  MESSAGEAPPEARED (state, payload) {
    state.appeared = payload
  },
  SETSTATISTICS (state, payload) {
    state.statistics = payload
  }
}
export const actions = {
  async adminLogin ({ dispatch }, formData) {
    const response = await this.$axios.$post('/verify-login-otp', formData)
    const token = response.data?.token || ''

    await dispatch('authProfile/setToken', token, { root: true })

    localStorage.setItem(
      'subtoken',
      token.substring(token.length / 2, token.length / 2 + 10)
    )
    // Load user profile + permissions immediately after login
    await dispatch('authProfile/loadProfile', null, { root: true })
    this.commit('authProfile/SET_PERMISSIONS_LOADED', true)

    return response
  },

  async sendLoginOtp (_, formData) {
    const response = await this.$axios.$post('/send-login-otp', formData)
    return response
  },

  async adminLogout ({ dispatch }, payload) {
    const response = await this.$axios.$post('/logout', {
      device_id: payload
    })
    await dispatch('authProfile/reset', null, { root: true })
    return response
  },
  async activateEmail ({ commit }, formData) {
    const response = await this.$axios.$post(
      '/resend-activation-email',
      formData
    )

    return response
  },
  async checkEmailActivate ({ commit }, payload) {
    const response = await this.$axios.$post('/activate-account', payload)

    return response
  },
  async getStatistics ({ commit }) {
    await this.$axios.$get('/statistics').then((response) => {
      commit('SETSTATISTICS', response.data)
    })
  }
}
